import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    height: 'calc(100vh - 58px)',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    color: 'white',
  },
  dashboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    textAlign: 'center',
    alignContent: 'center',
  },
  margin: {
    marginRight: '12px',
  },
  examIcon: {
    marginRight: '12px',
    marginTop: '2px',
  },
  button: {
    backgroundColor: '#347F42',
    color: '#FFFFFF',
    border: 0,
    width: '180px',
    '&:hover': {
      backgroundColor: '#266733',
    },
  },
  SwitchDashboardTypeButtons: {
    border: 'solid 1px #FFFFFF',
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'left',
    marginBottom: 12,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '10vw',
  },
  progressButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  statisticContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  iconHover: {
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
      '& path': {
        fill: '#3C419A',
      },
    },
  },
  pageHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
  },
  buttonHeader: {
    margin: '30px 0px 30px -480px',
  },
  overflowContainer: {
    height: '65vh',
    width: '100%',
    overflowY: 'auto',
    paddingBottom: '16px',
    outline: 'none'
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexStart: 'left',
  },
  header: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '22vw',
  },
  sidebar: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '80%',
  },
  sessionName: {
    fontWeight: 600,
    fontSize: '16px',
    maxWidth: '54%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  sessionDuration: {
    fontWeight: 500,
    fontSize: '14px',
  },
  calendarIcon: {
    marginRight: '5px',
    marginTop: '2px',
    marginBottom: '-2px',
  },
  h5Style: {
    fontSize: '1.25em !important',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    color: 'white',
  }
}));
